const CompanyStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
})
export default CompanyStatus
// RESERVE BELOW
